import React from 'react';
import Create from '../../../create';

export default function BookParcel() {
  const schema = [
    {
      tabName: 'Rider Details',
      editFields: [
        {
          label: 'Rider Name',
          name: 'name',
          type: 'text',
        },
        {
          label: 'Contact Number',
          name: 'number',
          type: 'text',
        },
        {
          label: 'Phone Number for Login',
          name: 'username',
          type: 'text',
        },
        {
          label: 'Email',
          name: 'email',
          type: 'text',
        },
        {
          label: 'Password',
          name: 'password',
          type: 'text',
        },
      ],
    },
  ];
  return (
    <Create
      return="/dashboard/rider"
      url={`${process.env.REACT_APP_API_SERVER}/riders`}
      dataID={null}
      schema={schema}
    />
  );
}
